import axios from 'axios';
import type { AxiosInstance, AxiosError, AxiosRequestConfig } from 'axios';

import config from 'src/config';
import helpers from 'src/utils/helpers';
import getAuthString from './getAuthString';
import refreshToken from './refreshToken';
import type { ErrorResponseType } from './http.types';
import resetTokenForInstance from './resetTokenForInstance';

export const EXPIRED_ERROR_CODE = 'auth.token.expired';

const createErrorResponseHandler = (axiosInstance: AxiosInstance) => {
  return async (err: AxiosError<ErrorResponseType>) => {
    const request = err.config as AxiosRequestConfig & { numberOfAttempts: number };

    if (
      err.message === 'Network Error' &&
      (request.numberOfAttempts || 0) < config.maxRequestNumberOfAttempts
    ) {
      await helpers.sleep(1000 * request.numberOfAttempts * 5);
      request.numberOfAttempts = (request.numberOfAttempts || 1) + 1;
      return axiosInstance.request(request);
    }

    const isNeedToBeRefreshed =
      request.url !== 'auth/sign-in' &&
      err.response?.data?.statusCode === 401 &&
      err.response?.data?.message === 'Unauthorized';

    if (isNeedToBeRefreshed) {
      const refreshResponse = await refreshToken();

      if (refreshResponse.isRefreshed) {
        if (!request.headers) {
          request.headers = {};
        }
        request.headers.authorization = getAuthString();
        resetTokenForInstance(axiosInstance);

        return axios(request);
      }
    }

    throw err;
  };
};

export default createErrorResponseHandler;
